module.exports = __webpack_public_path__ + "img/blob-scene-haikei.3e448e82.svg";